import { useRef } from 'react'
import { useIntlConfig } from '@monthio/react-components'

export const useCurrencySymbol = (currency?: string): string => {
	const { locale, currency: intlCurrency } = useIntlConfig({
		currency,
		showCurrency: true,
	})

	const currencySymbols =
		useRef<{ locale: string; currency?: string; symbol: string }[]>()
	if (!currencySymbols.current) {
		currencySymbols.current = []
	}

	const value = currencySymbols.current.find(
		(v) => v.locale === locale && v.currency === currency,
	)
	if (value) {
		return value.symbol
	}

	const formats = new Intl.NumberFormat(locale, {
		style: 'currency',
		currency: intlCurrency,
	})
	const symbol =
		formats.formatToParts().find((part) => part.type === 'currency')?.value ||
		currency ||
		intlCurrency ||
		''
	currencySymbols.current.push({ locale, currency, symbol })
	return symbol
}
